(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name                 : 'HotList',
		confirm_before_submit: true
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.birthday-month').click(function changeBirthday() {
			$('#birthday-month-hidden').val('change_months');

			form.confirm_before_submit = false;
			Adzuki.Form.registerForm(form);
		});

		$('.anniversary-month').click(function changeAnniversary() {
			$('#anniversary-month-hidden').val('change_months');

			form.confirm_before_submit = false;
			Adzuki.Form.registerForm(form);
		});

		$('.prior_purchase-month').click(function changePriorPurchase() {
			$('#prior_purchase-month-hidden').val('change_months');

			form.confirm_before_submit = false;
			Adzuki.Form.registerForm(form);
		});

		$('.w2n_surveys-month').click(function changeW2nSurveys() {
			$('#w2n_surveys-month-hidden').val('change_months');

			form.confirm_before_submit = false;
			Adzuki.Form.registerForm(form);
		});

		$('.virtual_event-month').click(function changeVirtualEvent() {
			$('#virtual_event-month-hidden').val('change_months');

			form.confirm_before_submit = false;
			Adzuki.Form.registerForm(form);
		});

		$('#birthday-actions').change(function birthdayActionChanged() {
			var input;

			$('#birthdays ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$(this).next().next().addClass('disabled');

				$('#birthday-cppod').addClass('hidden');
				$('#birthday-cppod').val('');
			} else if ($(this).val() === 'ecard') {
				$('#birthdays ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data("type") === 'birthday' && $(this).hasClass('disabled')) {
						$('#birthdays .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$(this).next().next().removeClass('disabled');

				$('#birthday-cppod').addClass('hidden');
				$('#birthday-cppod').val('');
			} else {
				if ($(this).val() === 'cppod') {
					$('#birthday-cppod').removeClass('hidden');
				} else {
					$('#birthday-cppod').addClass('hidden');
					$('#birthday-cppod').val('');
				}

				$(this).next().next().removeClass('disabled');
			}
		});

		$('#anniversary-actions').change(function anniversaryActionChanged() {
			var input;

			$('#anniversaries ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$(this).next().next().addClass('disabled');

				$('#anniversary-cppod').addClass('hidden');
				$('#anniversary-cppod').val('');
			} else if ($(this).val() === 'ecard') {
				$('#anniversaries ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data("type") === 'anniversary' && $(this).hasClass('disabled')) {
						$('#anniversaries .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$(this).next().next().removeClass('disabled');

				$('#anniversary-cppod').addClass('hidden');
				$('#anniversary-cppod').val('');
			} else {
				$(Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
					input = $(this).parents('.table-row').find(':input');
					input.prop('disabled', false);
				});

				if ($(this).val() === 'cppod') {
					$('#anniversary-cppod').removeClass('hidden');
				} else {
					$('#anniversary-cppod').addClass('hidden');
					$('#anniversary-cppod').val('');
				}

				$(this).next().next().removeClass('disabled');
			}
		});

		$('#prior_purchase-actions').change(function priorPurchaseActionChanged() {
			var input;

			$('#prior_purchases ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$(this).next().next().addClass('disabled');

				$('#prior_purchase-cppod').addClass('hidden');
				$('#prior_purchase-cppod').val('');
			} else if ($(this).val() === 'ecard') {
				$('#prior_purchases ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data("type") === 'prior_purchase' && $(this).hasClass('disabled')) {
						$('#prior_purchases .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$(this).next().next().removeClass('disabled');

				$('#prior_purchase-cppod').addClass('hidden');
				$('#prior_purchase-cppod').val('');
			} else {
				$(Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
					input = $(this).parents('.table-row').find(':input');
					input.prop('disabled', false);
				});

				if ($(this).val() === 'cppod') {
					$('#prior_purchase-cppod').removeClass('hidden');
				} else {
					$('#prior_purchase-cppod').addClass('hidden');
					$('#prior_purchase-cppod').val('');
				}

				$(this).next().next().removeClass('disabled');
			}
		});

		$('#w2n_surveys-actions').change(function priorPurchaseActionChanged() {
			var input;

			$('#w2n_surveys ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$(this).next().next().addClass('disabled');

				$('#w2n_surveys-cppod').addClass('hidden');
				$('#w2n_surveys-cppod').val('');

			} else if ($(this).val() === 'ecard') {
				$('#prior_purchases ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data("type") === 'w2n_surveys' && $(this).hasClass('disabled')) {
						$('#w2n_surveys .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$(this).next().next().removeClass('disabled');

				$('#w2n_surveys-cppod').addClass('hidden');
				$('#w2n_surveys-cppod').val('');

			} else {
				$(Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
					input = $(this).parents('.table-row').find(':input');
					input.prop('disabled', false);
				});

				if ($(this).val() === 'cppod') {
					$('#w2n_surveys-cppod').removeClass('hidden');
				} else {
					$('#w2n_surveys-cppod').addClass('hidden');
					$('#w2n_surveys-cppod').val('');
				}

				$(this).next().next().removeClass('disabled');
			}
		});

		$('#future_cruise_deposits-actions').change(function futureCruiseDepositsActionChanged() {
			var $btn = $('.future_cruise_deposits-submit');
			var input;

			$('#future_cruise_deposits ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$btn.addClass('disabled');
				$btn.prop('disabled', true);
			} else if ($(this).val() === 'ecard') {
				$('#future_cruise_deposits ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data('type') && $(this).data('type').indexOf('future_cruise_deposit') !== -1 && $(this).hasClass('disabled')) {
						$('#future_cruise_deposits .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$btn.removeClass('disabled');
				$btn.prop('disabled', false);
			} else {
				$(Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
					input = $(this).parents('.table-row').find(':input');
					input.prop('disabled', false);
				});

				$btn.removeClass('disabled');
				$btn.prop('disabled', false);
			}
		});

		$('#future_cruise_credits-actions').change(function futureCruiseCreditsActionChanged() {
			var $btn = $('.future_cruise_credits-submit');
			var input;

			$('#future_cruise_credits ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$btn.addClass('disabled');
				$btn.prop('disabled', true);
			} else if ($(this).val() === 'ecard') {
				$('#future_cruise_credits ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data('type') && $(this).data('type').indexOf('future_cruise_credit') !== -1 && $(this).hasClass('disabled')) {
						$('#future_cruise_credits .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$btn.removeClass('disabled');
				$btn.prop('disabled', false);
			} else {
				$(Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
					input = $(this).parents('.table-row').find(':input');
					input.prop('disabled', false);
				});

				$btn.removeClass('disabled');
				$btn.prop('disabled', false);
			}
		});

		$('#virtual_event-actions').change(function virtualEventActionChanged() {
			var input;

			$('#virtual_events ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
				input = $(this).parents('.table-row').find(':input');
				input.prop('disabled', false);
				$(this).parents('.table-row').removeClass('unselectable');
			});

			if ($(this).val() === '') {
				$(this).next().next().addClass('disabled');

				$('#virtual_event-cppod').addClass('hidden');
				$('#virtual_event-cppod').val('');
			} else if ($(this).val() === 'ecard') {
				$('#virtual_events ' + Adzuki.FaIcon.getIconSelectorName('envelope')).each(function checkEmails() {
					input = $(this).parents('.table-row').find(':input');

					if ($(this).data("type") === 'virtual_event' && $(this).hasClass('disabled')) {
						$('#virtual_events .check-all').prop('checked', false);
						$(this).parents('.table-row').removeClass('selected');
						$(this).parents('.table-row').addClass('unselectable');
						input.prop('checked', false);
						input.prop('disabled', true);
					}
				});

				$(this).next().next().removeClass('disabled');

				$('#virtual_event-cppod').addClass('hidden');
				$('#virtual_event-cppod').val('');
			} else {
				$(Adzuki.FaIcon.getIconSelectorName('envelope')).each(function resetChecks() {
					input = $(this).parents('.table-row').find(':input');
					input.prop('disabled', false);
				});

				if ($(this).val() === 'cppod') {
					$('#virtual_event-cppod').removeClass('hidden');
				} else {
					$('#virtual_event-cppod').addClass('hidden');
					$('#virtual_event-cppod').val('');
				}

				$(this).next().next().removeClass('disabled');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
